<template>
  <b-tooltip position="is-left" :label="this.$t('sondage.add-section-question')">
  <b-dropdown :mobile-modal="false" position="is-bottom-left" style="max-size:80px;margin-left:10px; margin-top:5px;">
       <img
       slot="trigger"
        src="@/assets/img/icons/move-section-icon.png"
        class="icon"
        alt="icon-section"
      />
    <b-dropdown-item style="padding:5px;font-size:12px;" @click="showDropdownListSection">
      <p><b-icon
        v-if="sections[this.indexSection].questions[indexQuestion].relation_section"
        type="is-success"
        pack="fas"
        icon="check"
        size="is-small"
      ></b-icon>
      {{" "}}{{$t('sondage.add-section-question')}}</p>
    </b-dropdown-item>
  </b-dropdown>
  </b-tooltip>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'DropdownBurgerQuestion',
  props: {
    indexQuestion: {
      type: Number,
      required: true
    },
    indexSection: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters(['sections'])
  },
  methods: {
    showDropdownListSection () {
      this.$store.commit('UDPATE_SECTIONS_OPTIONS', {
        type: 'update_question_relation_section',
        indexSection: this.indexSection,
        indexQuestion: this.indexQuestion,
        relation_section: !this.sections[this.indexSection].questions[this.indexQuestion].relation_section
      })
    }
  }
}
</script>

<style scoped>
.section {
  background: #424a60;
  color: white;
}
.icon {
  width: 17px;
  height: 17px;
  margin-top:2px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/question/section/dropdown/DropdownBurgerQuestion.vue